module.exports = "<div class=\"payment-progress-bar xl-flexbox\" ng-class=\"{'no': $ctrl.invoiceStep}\">\n  <div class=\"col xl-5-10\">\n      <div class=\"text\">\n          <span translate>common.payment.customer</span>\n      </div>\n  </div>\n  <div class=\"col xl-5-10 xl-right\">\n      <div class=\"text\" ng-class=\"{'no': $ctrl.invoiceStep}\">\n          <span translate>common.payment.pay</span>\n      </div>\n  </div>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/payment-progress/payment-progress.html
// module id = 301
// module chunks = 0